 import { createAsyncThunk } from '@reduxjs/toolkit'
import { gatewayRequestAxios } from '../../services/interceptor'

import { GATEWAY_API_GROUPS_URL } from '../../constants/urls'

const getParamsForGetGroups = (filter) => {
    const params = { limit: 500 }
if (filter) {
        params.q = filter;
    }
    return params
}

export const getGroups = createAsyncThunk('groups', async (filter) => {
    const response = await gatewayRequestAxios.get(GATEWAY_API_GROUPS_URL, {
      params: getParamsForGetGroups(filter),
    })
    return response.data
})
